// Google Tag Manager dataLayer helpers.
// Pushes structured events consumable by GTM tags (GA4, Ads, Meta CAPI, etc.).

type DataLayerEvent = Record<string, unknown> & { event: string };

function pushToDataLayer(payload: DataLayerEvent): void {
  if (typeof window === "undefined") return;
  const w = window as unknown as { dataLayer?: unknown[] };
  w.dataLayer = w.dataLayer || [];
  w.dataLayer.push(payload);
}

function newEventId(prefix: string): string {
  const rand = Math.random().toString(36).slice(2, 10);
  return `${prefix}_${Date.now().toString(36)}_${rand}`;
}

export interface SignUpEventInput {
  email: string;
  userId: string;
  firstName?: string;
  lastName?: string;
  country?: string; // 2-letter code (e.g. 'it', 'us')
  contentName?: string;
}

export function pushSignUpEvent(input: SignUpEventInput): string {
  const eventId = newEventId("signup");
  pushToDataLayer({
    event: "sign_up",
    event_id: eventId,
    status: "Completed",
    content_name: input.contentName ?? "Free Tier Account",
    user_email: input.email.trim().toLowerCase(),
    user_firstname: (input.firstName ?? "").trim(),
    user_lastname: (input.lastName ?? "").trim(),
    user_country: (input.country ?? "").trim().toLowerCase(),
    external_id: input.userId,
  });
  return eventId;
}

export interface PurchaseEventInput {
  value: number;
  currency?: string;
  contentName?: string;
  contentIds?: Array<string | number>;
  status?: string;
  userEmail?: string;
  userPhone?: string;
  externalId?: string;
}

export function pushPurchaseEvent(input: PurchaseEventInput): string {
  const eventId = newEventId("purchase");
  pushToDataLayer({
    event: "purchase",
    event_id: eventId,
    ecommerce: {
      value: input.value,
      currency: input.currency ?? "EUR",
      content_name: input.contentName ?? "Premium Subscription Plan",
      content_ids: input.contentIds ?? [],
      status: input.status?.trim() ?? "",
    },
    user_email: input.userEmail?.trim().toLowerCase(),
    user_phone: input.userPhone?.trim(),
    external_id: input.externalId,
  });
  return eventId;
}